import { createSlice } from '@reduxjs/toolkit';

export const chipInfoSlice = createSlice({
    name: 'chipInfo',
    initialState: {
        red: null,
        yellow: null,
        green: null,
        chipUpdate: false,
        chipBoolean: false,
    },
    reducers: {
        setChip: (state, action) => {
            action.payload.map((item) => {
                state[item.chip] = item.value;
            });
        },
        setUpdateChip: (state, { payload }) => {
            state.chipUpdate = payload;
        },
        setUpdateBoolean: (state, { payload }) => {
            state.chipBoolean = payload;
        },
    },
});
export const {
    setChip,
    setUpdateChip,
    setUpdateBoolean,
} = chipInfoSlice.actions;

export default chipInfoSlice.reducer;
